export const defaultBrand = {
  primary: '#2563eb',
  primaryHover: '#1d4ed8',
  primaryLight: '#eff6ff',
  font: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  ctaRadius: '0.8rem',
  ctaTextColor: '#ffffff',
  tagRadius: '0.6rem',
  cardRadius: '1.2rem',
};

export const linearGradient = (direction: string, stops: string[]) =>
  `linear-gradient(${direction}, ${stops.join(', ')})`;

export const lightPalette = {
  text: '#111827',
  textLight: '#374151',
  textLighter: '#626973',
  textLightest: '#5f6b7a',
  surface: '#ffffff',
  background: '#fafbfc',
  border: '#e5e7eb',
  fieldBorder: '#d1d5db',
  actionBorder: '#e5e7eb',
  controlBorder: '#8b8b8b',
  borderSubtle: 'rgba(0, 0, 0, 0.06)',
  borderHover: '#d1d5db',
  grey: '#d1d5db',
  greyLight: '#f3f4f6',
  greyLighter: '#f9fafb',
  error: '#dc2626',
  errorLight: '#fef2f2',
};

export const darkPalette = {
  text: '#f1f5f9',
  textLight: '#cbd5e1',
  textLighter: '#94a3b8',
  textLightest: '#8a97a8',
  surface: '#1e293b',
  background: '#0f172a',
  border: '#7c8ba1',
  fieldBorder: '#7c8ba1',
  actionBorder: '#7c8ba1',
  controlBorder: '#7c8ba1',
  borderSubtle: 'rgba(255, 255, 255, 0.08)',
  borderHover: '#94a3b8',
  grey: '#64748b',
  greyLight: '#334155',
  greyLighter: '#1e293b',
  error: '#f87171',
  errorLight: 'rgba(248, 113, 113, 0.15)',
};

export const editorLightPalette = {
  border: lightPalette.border,
  surface: lightPalette.surface,
  elevated: lightPalette.surface,
  text: lightPalette.text,
  textSecondary: lightPalette.textLight,
  textMuted: lightPalette.textLighter,
  textLight: lightPalette.textLightest,
  track: lightPalette.greyLight,
  line: lightPalette.border,
  colorScheme: 'light',
};

export const editorDarkPalette = {
  border: darkPalette.border,
  surface: darkPalette.surface,
  elevated: darkPalette.grey,
  text: darkPalette.text,
  textSecondary: darkPalette.textLight,
  textMuted: darkPalette.textLighter,
  textLight: darkPalette.textLightest,
  track: darkPalette.greyLight,
  line: darkPalette.border,
  colorScheme: 'dark',
};
